import { render, staticRenderFns } from "./OperationBox.vue?vue&type=template&id=704ada58&scoped=true&"
import script from "./OperationBox.vue?vue&type=script&lang=ts&"
export * from "./OperationBox.vue?vue&type=script&lang=ts&"
import style0 from "./OperationBox.vue?vue&type=style&index=0&id=704ada58&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "704ada58",
  null
  
)

export default component.exports